import {
    addNavMenuSection,
    registerFormInputComponent,
    RelationFormInputComponent,
    TextFormInputComponent,
} from '@vendure/admin-ui/core'

import { CkEditorFormInputComponent } from './components/ck-editor-form-input/ck-editor-form-input.component'
import { VdrCkEditorComponent } from './components/vdr-ck-editor/vdr-ck-editor'
import { Permission } from './generated/ui-types'

export default [
    addNavMenuSection({
        id: 'Pages',
        label: 'Oomnium',
        requiresPermission: Permission.ReadPages,
        items: [
            {
                id: 'Pages',
                label: 'Pages',
                routerLink: ['/extensions/pages/pages'],
                // Icon can be any of https://clarity.design/icons
                icon: 'book',
                requiresPermission: Permission.ReadPages,
            },
            {
                id: 'Sections',
                label: 'Sections',
                routerLink: ['/extensions/pages/sections'],
                icon: 'tag',
                requiresPermission: Permission.ReadPages,
            },
        ],
    }),
    registerFormInputComponent('vdr-ck-editor', VdrCkEditorComponent),
    registerFormInputComponent('ck-editor-form-input', CkEditorFormInputComponent),
    // `asset-relation-input` exists for the dashboard, where the default relation selector cannot
    // list our unnamed assets and cannot upload. The Angular UI already resolves `Asset` relations
    // to its own asset picker, so the id is aliased to the built-in component rather than left
    // unregistered (an unknown id logs an error and falls back to exactly this component).
    registerFormInputComponent('asset-relation-input', RelationFormInputComponent),
    // `full-width-text-input` is the built-in text input under a second id. Neither UI can be told
    // to span a `string` field by config alone — the Angular UI derives the span from the field
    // type and input component — but a field with a custom component always spans, and
    // `withFullWidthFields` passes that on to the dashboard as `ui.fullWidth`.
    registerFormInputComponent('full-width-text-input', TextFormInputComponent),
]
